import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

function LobbyActions({
  pendingTeamChoice,
  currentTeamReady,
  readyLoading,
  starting,
  humanTeamsCount,
  joiningFromUrl,
  joiningTeamSlot,
  onReadyClick,
  onLeaveGame,
  isFacilitator,
  facilitatorIsPlayer,
  enteringTeamId,
  statusMessage
}) {
  const { t } = useTranslation()

  return (
    <div className="lobby__actions">
      <div className="lobby__status-section">
        <span className="lobby__status-label">{t('lobby.status')}</span>
        <div className="lobby__status-message">
          <span className="lobby__status-dot" />
          <div>{statusMessage || t('lobby.waiting_for_players')}</div>
        </div>
      </div>

      <div className="lobby__actions-right">
        <button
          type="button"
          className="lobby__leave-btn"
          onClick={onLeaveGame}
          disabled={joiningFromUrl || joiningTeamSlot !== null || enteringTeamId !== null}
        >
          {t('lobby.exit_game')}
        </button>

        {!pendingTeamChoice && (!isFacilitator || facilitatorIsPlayer) && (
          <button
            type="button"
            className={currentTeamReady ? 'lobby__cancel-btn' : 'lobby__start-btn'}
            onClick={onReadyClick}
            disabled={readyLoading || starting || humanTeamsCount < 1}
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {readyLoading || starting
              ? t('lobby.starting')
              : currentTeamReady
              ? t('lobby.cancel')
              : t('lobby.start_game_btn')}
          </button>
        )}
      </div>
    </div>
  )
}

LobbyActions.propTypes = {
  pendingTeamChoice: PropTypes.bool,
  currentTeamReady: PropTypes.bool,
  readyLoading: PropTypes.bool,
  starting: PropTypes.bool,
  humanTeamsCount: PropTypes.number.isRequired,
  joiningFromUrl: PropTypes.bool,
  joiningTeamSlot: PropTypes.number,
  onReadyClick: PropTypes.func.isRequired,
  onLeaveGame: PropTypes.func.isRequired,
  isFacilitator: PropTypes.bool,
  facilitatorIsPlayer: PropTypes.bool,
  enteringTeamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  statusMessage: PropTypes.string
}

LobbyActions.defaultProps = {
  pendingTeamChoice: false,
  currentTeamReady: false,
  readyLoading: false,
  starting: false,
  joiningFromUrl: false,
  joiningTeamSlot: null,
  isFacilitator: false,
  facilitatorIsPlayer: false,
  enteringTeamId: null,
  statusMessage: null
}

export default LobbyActions
